/**
 * Copyright 2026, CS GROUP, https://www.cs-soprasteria.com/
 *
 * This file is part of AntFlow project.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React, { DetailedHTMLProps, HTMLAttributes, useRef, useState } from 'react';

type Props = DetailedHTMLProps<HTMLAttributes<HTMLPreElement>, HTMLPreElement>;
export const PreClipBoard: React.FC<Props> = (props) => {
  const [copied, setCopied] = useState(false);

  const ref = useRef<HTMLElement>(null);

  const copyCode = async () => {
    const text = ref.current?.innerText;
    navigator.clipboard.writeText(text!);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="relative my-4">
      <button
        className="absolute top-0 right-0 m-2 p-button p-component p-button-sm p-button-text text-white"
        onClick={copyCode}
      >
        <i className={`pi ${copied ? 'pi-check' : 'pi-copy'} mr-2`} />
        {copied ? 'Copied!' : 'Copy'}
      </button>
      <pre className="p-4 bg-gray-900 text-white overflow-auto border-round">
        <code ref={ref}>{props.children}</code>
      </pre>
    </div>
  );
};
